/**
 * The most people one registration may list. Beyond this, two
 * registrations. Shared so the Worker's input schema and the site's party
 * editor agree on the number.
 *
 * Raised from 12 to 60 on 29 Sep 2026 at the Singapore organisers' request
 * (fb_8d303e3caa15d2bd): one email holds one registration per day, so a
 * large group needs room in a single party rather than a second form.
 */
export const PARTY_MAX = 60;
